import React from 'react';
import styled, {useTheme} from 'styled-components/native';
import SkeletonPlaceholder from '../skeletonPlaceholder';
import {Theme} from '../../theme/lightTheme';

const Container = styled.View`
  width: 100%;
  align-items: center;
`;

const TableRowSkeleton = () => {
  const theme = useTheme() as Theme;
  return (
    <Container>
      {Array(10)
        .fill(0)
        .map((_, i) => i)
        .map(item => (
          <SkeletonPlaceholder
            key={item}
            width={'100%'}
            height={theme.text.s1 * 2}
            borderRadius={4}
            marginBottom={1}
          />
        ))}
    </Container>
  );
};

export default TableRowSkeleton;
